import { createFeatureSelector, MemoizedSelector } from '@ngrx/store';
import { SharedFeatureState } from '../interfaces/shared.interface';

export const selectFeatureStore: MemoizedSelector<object, SharedFeatureState> =
  createFeatureSelector('shared');
